var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/core-country-interstitial-buttons.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"o-row o-column o-extra-small--12 ";
if(!runtime.contextOrFrameLookup(context, frame, "isModal")) {
output += " o-large--5 ";
;
}
output += " c-interstitial__button-container\">\n\n    <div class=\"c-interstitial__buttons\">\n\n        <div class=\"o-column ";
if(runtime.contextOrFrameLookup(context, frame, "isModal")) {
output += " o-extra-small--12 ";
;
}
else {
output += " o-extra-small--6 ";
;
}
output += "\">\n\n            <a data-site-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "countryCodeInterstitial")),"localSiteId"), env.opts.autoescape);
output += "\" data-url=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "countryCodeInterstitial")),"localURL"), env.opts.autoescape);
output += "\" class=\"c-interstitial__button-leave js-choose-local-site\" href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "countryCodeInterstitial")),"localURL"), env.opts.autoescape);
output += "\" data-qa-country-interstitial-leave>\n                ";
output += runtime.suppressValue((lineno = 7, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "countryCodeInterstitial")),"localSiteTranslationKey")])), env.opts.autoescape);
output += "\n            </a>\n\n        </div>\n\n        <div class=\"o-column ";
if(runtime.contextOrFrameLookup(context, frame, "isModal")) {
output += " o-extra-small--12 ";
;
}
else {
output += " o-extra-small--6 ";
;
}
output += "\">\n\n            <a data-site-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "countryCodeInterstitial")),"contextPathSiteId"), env.opts.autoescape);
output += "\" class=\"c-interstitial__button-stay js-choose-context-path-site\" href=\"#\" data-qa-country-interstitial-stay>\n                ";
output += runtime.suppressValue((lineno = 15, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["choose-context-path-site"])), env.opts.autoescape);
output += "\n            </a>\n\n        </div>\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/core-country-interstitial-buttons.j2"] , dependencies)